import { renderUserRoleBadge } from '@/components/features/auth/auth'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { UserRole } from '@/domain/auth/auth'
import { useAuthStore } from '@/store/useAuthStore'
import { Clock, Server, User } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useHealthStatus } from '@/hooks/api/useHealth'
import { ServiceStatusBadge } from '@/components/ui/service-status-badge'
import { PageContainer } from '@/components/features/shared/PageContainer'
import { NavHeader } from '@/components/features/shared/NavHeader'

const COMPANY_NAME = 'Solar del Río' //TODO

function HealthStatusCard() {
  const { data: status, isLoading, error } = useHealthStatus()

  return (
    <ServiceStatusBadge
      status={status}
      isLoading={isLoading}
      error={error ? 'No se pudo cargar el estado de los servicios' : undefined}
    />
  )
}

export function HomePage() {
  const user = useAuthStore((state) => state.user)
  const hasAnyRole = useAuthStore((state) => state.hasAnyRole)
  const canViewServices = !hasAnyRole([UserRole.Employee])
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <PageContainer>
      <NavHeader hideBackButton>
        <h1 className="text-3xl font-bold tracking-tight">{COMPANY_NAME}</h1>
        <p className="text-muted-foreground capitalize">
          {now.toLocaleDateString('es-AR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </NavHeader>

      <Card className='max-w-2xl'>
        <CardHeader>
          <CardTitle>Bienvenido/a</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Hola, {user?.fullName || 'usuario'}.
          </p>
        </CardContent>
      </Card>

      <div className="grid gap-4 md:grid-cols-2 max-w-2xl">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Usuario</CardTitle>
            <User className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{user?.fullName || 'N/A'}</div>

            <div className="text-muted-foreground">
              Roles: {user?.roles?.length ? user.roles.map((role) => renderUserRoleBadge(role)) : <span>N/A</span>}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Hora actual</CardTitle>
            <Clock className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold font-mono">{now.toLocaleTimeString('es-AR', { hour12: false, timeZoneName: 'short' })}</div>
          </CardContent>
        </Card>
      </div>

      {canViewServices && (
        <Card className="max-w-2xl">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Estado de servicios</CardTitle>
            <Server className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <HealthStatusCard />
          </CardContent>
        </Card>
      )}
    </PageContainer>
  )
}
